import { render, staticRenderFns } from "./TableActionColumn.vue?vue&type=template&id=79f88966&"
import script from "./TableActionColumn.vue?vue&type=script&lang=js&"
export * from "./TableActionColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports